import { useTranslation } from "react-i18next";
import { BarChart3 } from "lucide-react";
import clsx from "clsx";
import { PAGE_TYPE_COLORS } from "./constants";

export const PageTypesChart = ({
  pageTypeSummary,
}: {
  pageTypeSummary?: Record<string, number>;
}) => {
  const { t } = useTranslation();

  if (!pageTypeSummary || Object.keys(pageTypeSummary).length === 0)
    return null;

  const sorted = Object.entries(pageTypeSummary).sort((a, b) => b[1] - a[1]);
  const max = Math.max(...sorted.map((s) => s[1]));
  const total = sorted.reduce((sum, [, count]) => sum + count, 0);

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden h-full">
      <div className="px-5 py-3.5 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-purple-50 flex items-center justify-center">
            <BarChart3 size={16} className="text-purple-600" />
          </div>
          <h3 className="text-sm font-semibold text-gray-900">
            {t("smartSurveyor.researchReport.pageTypes")}
          </h3>
        </div>
        <span className="text-xs font-medium text-gray-400">
          {total} {t("smartSurveyor.researchReport.pages")}
        </span>
      </div>
      <div className="p-5 space-y-3">
        {sorted.map(([type, count]) => (
          <div key={type}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs font-medium text-gray-600 capitalize">
                {type.replace(/_/g, " ")}
              </span>
              <span className="text-xs font-semibold text-gray-900">
                {count}
              </span>
            </div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className={clsx(
                  "h-full rounded-full transition-all",
                  PAGE_TYPE_COLORS[type] ?? "bg-gray-400",
                )}
                style={{ width: `${(count / max) * 100}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
